module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-06.8c3b25ca.jpg";